import { Styles } from 'react-select'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { dropdownStyles } from '../ocpp-settings/OcppSettings.style'

export const SAlert = styled.div<{ type?: 'error' | 'success' | 'info' }>`
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
    color: ${({ theme }) => theme.font.darkestColor};

    ${({ type, theme }) => {
        if (type === 'error') {
            return `
                background-color: ${theme.brandColors.CA_Light_Coral};
            `
        } else if (type === 'success') {
            return `
                background-color: ${theme.brandColors.CA_Light_Green};
            `
        } else
            return `
                background-color: ${theme.brandColors.CA_Mid_Blue};
            `
    }}
`

export const chargePointDetailsDropdownStyles:
    | Partial<
          Styles<
              {
                  label: string
                  value: string
              },
              false
          >
      >
    | undefined = {
    ...dropdownStyles,
    option: (styles) => ({
        ...styles,
        padding: '10px 10px',
    }),
    singleValue: (styles, state) => ({
        ...styles,
        fontSize: 14,
        color: state.isDisabled ? '#a1a1a1' : '#555555',
        padding: '19px 10px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '100%',
        textOverflow: 'ellipsis',
        cursor: 'pointer',
    }),
    placeholder: (styles) => ({
        ...styles,
        fontSize: 14,
        color: '#555555',
        padding: '0 10px',
    }),
}

export const SFormControl = styled.input`
    max-width: 100%;
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1em;
    color: #555;
    font-weight: var(--font-weight-light);
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);

    &:disabled {
        cursor: not-allowed;
        background-color: #eee;
        opacity: 1;
    }
`

export const STable = styled.table`
    width: 100%;
    overflow: auto;
    table-layout: fixed;
`

export const SLink = styled.button`
    color: ${({ theme }) => theme.font.linkColor};
    background: none;
    border: none;
    padding: 0;

    &:hover {
        color: ${({ theme }) => theme.brandColors.CA_Blue};
        text-decoration: underline;
    }
    &:active {
        color: ${({ theme }) => theme.font.darkestColor};
        text-decoration: none;
    }
`

export const SActions = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 15px;
    margin-top: 20px;
`

export const SInstallationMessage = styled.p`
    border: 1px solid orange;
    border-radius: 4px;
    padding: 15px;
    color: black;
    font-weight: var(--font-weight-bold);
    background-color: #f9e49c6b;
`
export const SRow = styled.div`
    display: flex;
    flex-direction: row;
`
export const SConnectorWrapper = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.sizing.margin.xl};
`

export const SConnectorDiv = styled.div`
    width: 100%;
`

export const Sborder = styled.div`
    border: 1px solid ${({ theme }) => theme.brandColors.CA_Light_Gray};
    border-width: 0px 0px 1px 0px;
    width: 100%;
    margin: 20px 0px;
`
export const SIcon = styled(FontAwesomeIcon)`
    margin-top: 7px;
    font-size: 19px;
`

export const SActionBtn = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 3px;
`
